import React from 'react';
import MediaContainer from '../containers/media.container';
import TenantGuard from '@components/common/TenantGuard';

export const mediaRoutes = [
  {
    path: 'file-manager',
    element: (
      <TenantGuard showHeader={true} headerTitle="File Manager" showBreadcrumbs={true}>
        <MediaContainer />
      </TenantGuard>
    ),
  },
];

export default mediaRoutes;

